export default "__VITE_ASSET__QnDQv0rv__"